import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAddAssignmentMutation, useEditAssignmentMutation } from '../../../redux/features/assignment/assignmentApi';
import Error from "../../ui/Error";



const stringSorter = (string, letterQYT) => ((string.length > letterQYT) ? string.slice(0, letterQYT) + "..." : string)

export default function AssignmentForm({ handleOut, videos }) {
    const { isEdit, data } = useSelector((state) => state.edit) || {};

    const [input, setInput] = useState({
        title: "",
        totalMark: "",
        video: videos[0]?.id,
    });

    const [errorState, setError] = useState(false);
    const [addAssignment, { isError, isSuccess }] = useAddAssignmentMutation();
    const [editAssignment, { isError: isErrorEdit, isSuccess: isSuccessEdit }] = useEditAssignmentMutation();

    const changeHandler = (e) => {
        setInput((prev) => {

            return {
                ...prev,
                [e.target.name]: e.target.value
            }

        })
    }
    const submitHandler = (e) => {
        setError(false)
        e.preventDefault();

        const video_title = videos?.find(item => item.id === Number(input.video))?.title
        const video_id = Number(input.video)

        if (isEdit) {
            editAssignment({
                id: data?.id,
                data: {
                    id: data.id,
                    title: input.title,
                    video_id,
                    video_title,
                    totalMark: Number(input.totalMark)
                }
            })
        } else {
            // check video url valid or not
            addAssignment({
                title: input.title,
                video_id,
                video_title,
                totalMark: Number(input.totalMark)
            })
        }
    }
    // error state set 
    useEffect(() => {
        if (isError || isErrorEdit) { setError("There was and error") }
        if (isSuccess || isSuccessEdit) { handleOut(false) }
    }, [handleOut, isError, isErrorEdit, isSuccess, isSuccessEdit])

    useEffect(() => {
        if (isEdit) {
            setInput({
                ...data,
                video: data?.video_id
            })

        }
    }, [data, isEdit, videos])

    return (
        <>
            {errorState && <Error message={errorState} />}
            <form onSubmit={submitHandler} className="mt-5 p-6">
                <div className="mb-6">
                    <label htmlFor="title" className="block mb-2 text-sm font-medium text-white">Assignment title</label>
                    <input name='title' type="text" id="title" className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                        value={input.title}
                        onChange={changeHandler}
                    />
                </div>
                <div className="grid gap-6 md:grid-cols-2">
                    <div className="mb-6">
                        <label htmlFor="video" className="block mb-2 text-sm font-medium text-white">Associated Video</label>
                        <select type="text" id="video" name='video' className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                            value={input.video}
                            onChange={changeHandler}>

                            {videos.map(video =>
                                <option key={video.id}
                                    value={video.id}>
                                    {stringSorter(video?.title, 50)}
                                </option>
                            )}

                        </select>
                    </div>
                    <div>
                        <label htmlFor="totalMark" className="block mb-2 text-sm font-medium text-white">Total Mark</label>
                        <input type="number" id="totalMark" name='totalMark' className="border  text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required
                            value={input.totalMark}
                            onChange={changeHandler}
                        />
                    </div>
                </div>
                <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
            </form>
        </>
    )
};